import styled from 'styled-components'

import { Image as ImageBase } from '@application/Interfaces/Atoms/Image'
import { TitleSection as TitleSectionBase } from '@organisms/TitleSection'

export const Image = styled(ImageBase)`
    max-width: 42px;
    margin: 0 auto;
`

export const Title = styled.h3`
    display: block;
    margin-bottom: 14px;
    margin-top: 20px;
    text-align: center;
    ${(props) => props.theme.typo.bodyL}
    ${(props) => props.theme.fontWeight.medium};
    line-height: 180%;
`

export const TitleSection = styled(TitleSectionBase)`
    background-color: ${(props) => (props.mode === 'Dark' ? props.theme.color.p600 : props.theme.color.g100)};

    ${Title} {
        color: ${(props) => props.theme.color[props.mode === 'Dark' ? 'g100' : 'g600']};
    }
`
